export default __webpack_public_path__ + "static/media/sports17.11efd32c.jpg";